import {
    init as initAmplitude,
    track as trackAmplitude,
    identify as identifyAmplitude,
    Identify,
    getDeviceId as getDeviceIdFromAmplitude,
    setUserId
} from '@amplitude/analytics-browser';
import { subscribe } from './event-logger';
import { AMPLITUDE_EVENT_TYPES, EVENT_TYPES } from './event-types';
import { getCookie, setCookie } from './cookie-helpers';
import { uiConfig } from '../../ui/app-ui-config';

const amplitudeTracker = {
    DEVICE_ID_KEY: uiConfig.deviceIdKey,
    DAYS_IN_YEAR: 365,

    init(apiKey, serverUrl) {
        if (!apiKey) return;

        const deviceId = amplitudeTracker.getDeviceId();

        initAmplitude(apiKey, undefined, {
            includeUtm: true,
            minIdLength: 1,
            autocapture: false,
            transport: 'beacon',
            serverUrl,
            ...(Boolean(deviceId) ? { deviceId } : {})
        });

        const identifyData = new Identify();

        amplitudeTracker.setUserProperties(identifyData);
    },

    getDeviceIdFromStorage() {
        return getCookie(amplitudeTracker.DEVICE_ID_KEY);
    },

    setDeviceIdToStorage(deviceId = '') {
        if (deviceId) {
            setCookie(amplitudeTracker.DEVICE_ID_KEY, deviceId, amplitudeTracker.DAYS_IN_YEAR);
        }
    },

    getDeviceId() {
        let deviceId = amplitudeTracker.getDeviceIdFromStorage();

        if (!deviceId) {
            deviceId = getDeviceIdFromAmplitude() || window.crypto?.randomUUID?.();

            amplitudeTracker.setDeviceIdToStorage(deviceId);
        }

        return deviceId || '';
    },

    setUserId(userId) {
        setUserId(userId ? `${userId}` : userId);
    },

    track(eventType, eventProperties = {}) {
        trackAmplitude(eventType, eventProperties);
    },

    setUserProperties(identifyData) {
        identifyAmplitude(identifyData);
    },

    reset() {
        amplitudeTracker.setUserId(undefined);
    },

    onSubscribe() {
        return subscribe((eventType, eventProperties = {}, additionalEventProperties = {}) => {
            if (eventType === EVENT_TYPES.USER_ID) {
                return amplitudeTracker.setUserId(eventProperties);
            }

            if (eventType === EVENT_TYPES.USER_PROPERTIES) {
                const identifyData = new Identify();

                Object.entries(eventProperties).map(property => identifyData.set(...property));

                return amplitudeTracker.setUserProperties(identifyData);
            }

            if (AMPLITUDE_EVENT_TYPES.hasOwnProperty(eventType)) {
                if (typeof AMPLITUDE_EVENT_TYPES[eventType] === 'function') {
                    return amplitudeTracker.track(AMPLITUDE_EVENT_TYPES[eventType](eventProperties), additionalEventProperties);
                }

                amplitudeTracker.track(AMPLITUDE_EVENT_TYPES[eventType], eventProperties);
            }
        });
    }
};

export {
    amplitudeTracker
};
